module.exports = __webpack_public_path__ + "static/media/donna-tablet.e2142ddc.jpg";